import http from "../utils/http-common";

const get = (id: number) => {
  return http.get(`/case/${id}`);
};
const put = (id: number, data: any) => {
  return http.put(`/case/${id}`, data);
};
const remove = (id: number) => {
  return http.delete(`/case/${id}`);
};
const post = (data: any) => {
  return http.post(`/case`, data);
};
const getBySuiteId = (suiteId: number) => {
  return http.get(`/case/suite/${suiteId}`);
};
const getByAgentId = (agentId: string) => {
  return http.get(`/case/agent/${agentId}`);
};
const getAll = (params: string) => {
  const queryString = new URLSearchParams(params).toString();
  return http.get(`/case?${queryString}`);
};
// const getAll = () => {
//   return http.get(`/case`);
// };
export const caseService = {
  get,
  put,
  remove,
  post,
  getAll,
  getBySuiteId,
  getByAgentId,
};
export default caseService;
